import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import NavigationHelper from '@/Management/NavigationHelper';
import RADApplication from '@/Management/RADApplication';
import SimpleLinkBuilder from '@/Builder/SimpleLinkBuilder';
import * as DownloadHelper from '@/Utility/DownloadHelper';
import Utilities from '@/Utility/Utilities';

export default class EmbeddedMediumLinkColumnFactory extends ColumnFactory {
    public static isPlainText = false;
    public static isJQueryElement = true;
    private embeddedMediumAttribute: string;

    constructor(params: any) {
        super(params);

        this.embeddedMediumAttribute = this.paramOrDefault(params.embeddedMediumAttribute, '');
    }

    public getValue(): JQuery {
        if (Utilities.isNullOrUndefinedOrBlank(this.raw))
            return $('').append(document.createTextNode(''));

        let link : HTMLElement;
        if (Utilities.isUrl(this.raw)) {
            link = new SimpleLinkBuilder()
                .withCaption(this.raw)
                .withOnClick((openInNewWindow) => {
                    NavigationHelper.openWebPage(this.raw, '_blank');
                })
                .buildAndGetElement();
        }
        else {
            let attributeName = '';
            if (!String.isNullOrEmpty(this.embeddedMediumAttribute))
                attributeName = this.embeddedMediumAttribute
            else
                attributeName = this.field ? this.field.replace('_Filename', '') : '';

            link = new SimpleLinkBuilder()
                .withCaption(this.raw)
                .withOnClick(() => {
                    DownloadHelper.openDownloadDialogFromApplicationAsync(`${RADApplication.getInstance().radEnvironmentMediumHandler}?PDOID=${this.row.PDO_ID}&AttributeName=${attributeName}&WithoutLock=true`);
                })
                .buildAndGetElement();

        }
        link.classList.add('c-embeddedmediumlinkcolumn');

        return $(link);
    }
}

ComponentManager.setFactory('EmbeddedMediumLinkColumn', EmbeddedMediumLinkColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');